import axios from './axios-instance'

const BASEURL = '/experience'

export default {
  async get() {
    return axios.get(BASEURL)
  },
}
